import { TickerManagementUserControls } from './components/ticker-management-user-controls.tsx'
import { useAppSelector } from '../../redux/hooks.ts'
import { selectManagementInput } from '../../redux/slices/management-input.slice.ts'
import { useListManagedTickersQuery } from '../../apis/ticker-management/ticker-management-api.api.ts'
import { TickerManagementTable } from './components/ticker-management-table.tsx'
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import { TickerManagementFormFieldTypes } from './components/ticker-modal/ticker-action/ticker-management-form.tsx'
import { useMemo, useRef, useState } from 'react'
import Form from 'antd/es/form/index'
import { ManagedTickerData } from '../../apis/ticker-management/ticker-management-api.def.ts'
import { ActionTickerModal } from './components/ticker-modal/ticker-action/action-ticker-modal.tsx'
import { useTableHeight } from '../../common/hooks/use-table-height.ts'
import { splitCategory } from '../../utils/selector-options.ts'

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

export const TickerManagement = () => {
  const [showActionTickerModal, setShowActionTickerModal] =
    useState<boolean>(false)
  const managementInput = useAppSelector(selectManagementInput)
  const [form] = Form.useForm<TickerManagementFormFieldTypes>()
  const [editTicker, setEditTicker] = useState<ManagedTickerData | null>(null)
  const headerRef = useRef<HTMLDivElement>(null)
  const tableHeight = useTableHeight(headerRef)

  const handleCloseModal = () => {
    form.resetFields()
    setShowActionTickerModal(false)
    setEditTicker(null)
  }

  const { region } = splitCategory(managementInput.category)

  const { data, isFetching, isLoading } = useListManagedTickersQuery({
    region: region,
    expired: managementInput.expiredTicker,
  })

  const handleEditTicker = (id: string) => {
    setShowActionTickerModal(true)
    const ticker = data?.data.find((x) => x.id === id)
    if (ticker) setEditTicker(ticker)
  }

  const filteredTickerList = useMemo(() => {
    return data?.data ?? []
  }, [data])

  return (
    <>
      <div ref={headerRef}>
        <TickerManagementUserControls
          onCreateTicker={() => setShowActionTickerModal(true)}
        />
      </div>
      <TickerManagementTable
        isLoading={isLoading}
        isFetching={isFetching}
        //tickerManagementList={data?.data ?? []}
        tickerManagementList={filteredTickerList}
        onEditTicker={handleEditTicker}
        height={tableHeight}
      />
      <ActionTickerModal
        showActionModal={showActionTickerModal}
        form={form}
        handleCloseModal={handleCloseModal}
        tickerData={editTicker as ManagedTickerData}
      />
    </>
  )
}
